import firebase from 'firebase/app';
import 'firebase/firestore';
import notifications from '../plugins/tl-notifications';

const firestore = firebase.firestore();
// if (process.env.NODE_ENV === 'development') {
//   firestore.useEmulator("192.168.5.39", 8080);
// }

let listeners = [];

const tripRef = (tripId) => firestore.collection('groups').doc(tripId);

const getHeaderImage = (context, headerCapable) => {
  if (!headerCapable.files || !headerCapable.files.header) return;
  // console.log('getting header of', headerCapable.name)
  context.dispatch('getImageUrl', { path: headerCapable.files.header, id: headerCapable.id });
};

const addListener = (context, ref, collection, modifiedCallback) => {
  const listener = ref.onSnapshot((snapshot) => {
    snapshot.docChanges().forEach((change) => {
      const document = { ...change.doc.data(), id: change.doc.id, collection };

      if (change.type === "removed") {
        console.log('removed document');
        context.commit('deleteTripCollectionDocument', { collection, documentId: change.doc.id });
      } else {
        if (modifiedCallback) {
          modifiedCallback(document, change.type);
        }
        context.commit('updateTripCollectionDocument', { collection, document });
      }
    });
  }, (error) => {
    console.log(error);
  });
  listeners.push(listener);
};

const addSubcollectionListener = (context, tripId, collection, trackDelete, modifiedCallback) => {
  let ref = tripRef(tripId).collection(collection);
  if (trackDelete || false) {
    ref = ref.where('deleted', '==', false);
  }

  addListener(context, ref, collection, modifiedCallback);
};

const deleteDocument = (tripId, collection, documentId) => {
  tripRef(tripId).collection(collection).doc(documentId).delete();
};

const observeEvents = (context, tripId) => {
  addSubcollectionListener(context, tripId, 'events', true, (event) => {
    getHeaderImage(context, event);
    // eslint-disable-next-line no-param-reassign
    event.sortingDate = event.location.date.toDate();
    // eslint-disable-next-line no-param-reassign
    event.display_timezone = event.location && event.location.time_zone ?
      event.location.time_zone : event.time_zone;
    if (event.time_zone === 'US/Pacific') {
      // eslint-disable-next-line no-param-reassign
      event.time_zone = 'America/Los_Angeles';
    }
  });
};

const observeTravels = (context, tripId) => {
  addSubcollectionListener(context, tripId, 'travels', true, (travel) => {
    getHeaderImage(context, travel);
    // eslint-disable-next-line no-param-reassign
    travel.sortingDate = travel.origin.date.toDate();
    // eslint-disable-next-line no-param-reassign
    travel.display_timezone = travel.origin && travel.origin.time_zone ?
      travel.origin.time_zone : travel.time_zone;
    if (travel.time_zone === 'US/Pacific') {
      // eslint-disable-next-line no-param-reassign
      travel.time_zone = 'America/Los_Angeles';
    }
  });
};

const observeFlights = (context, tripId) => {
  addSubcollectionListener(context, tripId, 'flights', true, (flight) => {
    getHeaderImage(context, flight);
    // eslint-disable-next-line no-param-reassign
    flight.sortingDate = flight.departure_date.toDate();
  });
};

const observeCities = (context, tripId) => addSubcollectionListener(context, tripId, 'cities', false);

const observeMaps = (context, tripId) => addSubcollectionListener(context, tripId, 'maps', true);

const observePostComments = (context, tripId, postId) => {
  const ref = tripRef(tripId).collection('feed').doc(postId).collection("comments")
    .orderBy("date", "asc");

  const listener = ref.onSnapshot((snapshot) => {
    snapshot.docChanges().forEach((change) => {
      const document = { ...change.doc.data(), id: change.doc.id };
      if (change.type === "added") {
        context.commit('postCommentAdded', { postId, document });
      }
    });
  });
  listeners.push(listener);
};

const observePosts = (context, tripId) => {
  addSubcollectionListener(context, tripId, 'feed', true, (post, update) => {
    if (update === "added") {
      notifications.newPostNotification(post);
      observePostComments(context, tripId, post.id);
    }
  });
};

const observePolls = (context, tripId) => addSubcollectionListener(context, tripId, 'polls', true);

const observeSubgroups = (context, tripId) => addSubcollectionListener(context, tripId, 'subgroups', false);

const observeSurveys = (context, tripId) => addSubcollectionListener(context, tripId, 'surveys', true);

const observeScheduled = (context, tripId) => addSubcollectionListener(context, tripId, 'scheduled');

const observeChats = (context, tripId) => {
  const meId = context.rootState.firUser.uid;
  const ref = tripRef(tripId).collection('chats').where(`users.${meId}`, '==', true);

  addListener(context, ref, 'chats', (conversation, update) => {
    if (update === "added") {
      context.dispatch('observeMessages', conversation.id);
    }
    if (conversation.image_path) {
      context.dispatch('getImageUrl', { path: conversation.image_path, id: conversation.id });
    }
  });
};

let privateListeners = [];
const listenCompanyPrivate = (context, companyId) => {
  if (privateListeners.includes(companyId)) return;
  privateListeners.push(companyId);
  console.log("listeing private info for ", companyId);
  const ref = firestore.collection('companies').doc(companyId).collection("private").doc("private");

  const listener = ref.onSnapshot((doc) => {
    context.commit('updateCollectionDocument', { collection: 'companiesPrivate', document: { ...doc.data(), id: companyId } });
  });
  listeners.push(listener);
};

const getCompany = (context, companyId) => {
  console.log(`fetching company ${companyId}`);
  firestore.collection('companies').doc(companyId).get().then((snapshot) => {
    const company = { ...snapshot.data(), id: companyId };
    context.commit('updateCollectionDocument', { collection: 'companies', document: company });
    if (company.logo) {
      context.dispatch('getImageUrl', { path: company.logo, id: company.id });
    }
  });
};

const observeTrip = (context, tripId) => {
  console.log("observing trip");
  const listener = firestore.collection('groups').doc(tripId).onSnapshot((doc) => {
    console.log("trip updated");
    const trip = { ...doc.data(), id: tripId };
    context.commit('updateTripDocument', { collection: 'trip', document: trip });
    context.dispatch('observeTripUsers', trip);
    console.log('observetrip');
    getHeaderImage(context, trip);
    console.log("companies are", context.rootState.companies);
    if (trip.company && !context.rootState.companies[trip.company]) {
      getCompany(context, trip.company);
    }
  }, (error) => {
    console.log(error);
  });
  listeners.push(listener);

  observeEvents(context, tripId);
  observeCities(context, tripId);
  observeMaps(context, tripId);
  observeTravels(context, tripId);
  observeFlights(context, tripId);
  observePosts(context, tripId);
  observeScheduled(context, tripId);
  observeChats(context, tripId);
  observeSurveys(context, tripId);
  observePolls(context, tripId);
  observeSubgroups(context, tripId);
};

const writeDocument = (tripId, collection, data, documentId) => {
  if (documentId) {
    return tripRef(tripId).collection(collection).doc(documentId).update(data);
  }
  return tripRef(tripId).collection(collection).add(data);
};

const writeTrackedDocument = (tripId, collection, data, documentId, deleted) => {
  const event = {
    ...data,
    modified: new Date(),
    server_modified: firebase.firestore.FieldValue.serverTimestamp(),
    deleted: deleted || false,
  };

  return writeDocument(tripId, collection, event, documentId);
};

const writePostComment = async (tripId, postId, data) => {
  console.log("write post comment");
  const ref = await tripRef(tripId).collection("feed").doc(postId).collection("comments")
    .add({
      ...data,
      server_modified: firebase.firestore.FieldValue.serverTimestamp(),
    });

  const update = {};
  update[`comment_ids.${ref.id}`] = true;
  console.log("updating post ", update);
  writeTrackedDocument(tripId, "feed", update, postId);
};

const updateSubgroup = (tripId, subgroupId, data) => {
  const ref = firestore.collection('groups').doc(tripId).collection("subgroups").doc(subgroupId);
  return ref.update(data);
};

const getGeo = (coordinates) => (coordinates ?
  new firebase.firestore.GeoPoint(coordinates.lat, coordinates.long) : null);

const writeCity = (tripId, collection, cityName, data) => {
  const city = { ...data };
  city.north_east = getGeo(data.north_east);
  city.south_west = getGeo(data.south_west);
  city.center = getGeo(data.center);
  if (!city.north_east || !city.south_west) {
    console.log("no north_east or south_west", city);
    return 'error';
  }
  return tripRef(tripId).collection(collection).doc(cityName).set(city);
};

const createTrip = (data) => firestore.collection('groups').add(data);

const updateTrip = (tripId, data) => tripRef(tripId).update(data);

const updateCompany = (companyId, data) => firestore.collection('companies').doc(companyId).update(data);

const listenTrips = (context, userId) => {
  console.log('requesting trips with id: ', userId);
  firestore.collection('groups')
    .where(`user_ids.${userId}`, '==', true).onSnapshot((snapshot) => {
      const trips = snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
        .filter((trip) => trip.deleted !== true);
      trips.forEach((trip) => {
        getHeaderImage(context, trip);
        if (!trip.start_date) {
          // eslint-disable-next-line no-param-reassign
          trip.start_date = new firebase.firestore.Timestamp(0, 0);
        }
        if (!trip.end_date) {
          // eslint-disable-next-line no-param-reassign
          trip.end_date = new firebase.firestore.Timestamp(0, 0);
        }
      });
      context.commit('tripsUpdated', trips);
    });
};

const getCompanies = (context, userId) => {
  console.log(`fetching companies for ${userId}`);

  firestore.collection('companies').where(`admins.${userId}`, '==', true).onSnapshot((snapshots) => {
    console.log("companies returned");
    snapshots.docChanges().forEach((change) => {
      const company = ({ ...change.doc.data(), id: change.doc.id });

      if (change.type === 'added') {
        context.dispatch("observeCompanyUsers", company);
      }

      context.commit('updateCollectionDocument', { collection: 'companies', document: company });
      if (company.logo) {
        context.dispatch('getImageUrl', { path: company.logo, id: company.id });
      }
    });
    console.log("updating'ObtainedCOmpanies' to true");
    context.commit('updateValue', { collection: 'obtainedCompanies', value: true });
  });
};

const unsubscribeListeners = () => {
  listeners.forEach((listener) => listener());
  listeners = [];
  privateListeners = [];
};

const fieldArrayUnion = firebase.firestore.FieldValue.arrayUnion;
const fieldDelete = firebase.firestore.FieldValue.delete;
const generateId = () => firestore.collection("any").doc().id;

export default {
  updateSubgroup,
  observeTrip,
  listenTrips,
  unsubscribeListeners,
  deleteDocument,
  updateTrip,
  createTrip,
  // observeFeed,
  writeTrackedDocument,
  getGeo,
  writeDocument,
  writeCity,
  getCompanies,
  fieldDelete,
  fieldArrayUnion,
  generateId,
  updateCompany,
  tripRef,
  writePostComment,
  getCompany,
  listenCompanyPrivate,
};
